<template>
	<div class="hd-moa-frame-molecules js-moa-frame-molecules">
		<base-image-svg 
			:source="require('!html-loader!../../assets/svgs/20-moa-frame-molecules.svg')"
		/>
	</div>
</template>

<style lang="scss" scoped>
	.hd-moa-frame-molecules {
		@include fade-out();
		max-width: 600px;

		:deep() svg {
			max-width: 600px;
		}

		// Animation 
		&[data-state="animation-ready"] {
			opacity: 1;
		}

		// Responsive
		@include res-screen-small {
			:deep() svg {
				max-width: 500px;
			}
		}
		@include res-screen-small {
			:deep() svg {
				max-height: 430px;
			}
		}
		@include res-screen-portrait {
			@include center();
			:deep() svg {
				margin-top: 100px;
				max-height: 500px;
			}
		}

		@include res-screen-portrait-sm {
			top: 56%;

			:deep() svg {
				max-height: 300px;
			}
		}
	}
</style>